export { default as default } from './KitFrame';
